import React from 'react';
import styled from 'styled-components';

import { Moon } from '@lt/components/icons-react/userflow';
import ButtonTs from '@lt/components/components/ButtonTs';

import { getRangeNightsString } from '../Calendar/utils';

import type { Nights } from '@lt/api/dist/types/searchParams';
import type { CalendarProps } from '../Calendar/types';
import type { DateCell } from '../../types';
import { convertNightsIntervalToString } from '../../../../utils';

type Props = Pick<CalendarProps, 'isMobile'> & {
  startDateCell: DateCell;
  endDateCell: DateCell;
  nights?: Nights;
  selectPresetTab: () => void;
  isVacationOptionsAvailable: boolean;
};

export const NightsInfo = ({
  startDateCell,
  endDateCell,
  nights,
  isMobile,
  selectPresetTab,
  isVacationOptionsAvailable,
}: Props): JSX.Element => {
  const { date: startDate } = startDateCell;
  const { date: endDate } = endDateCell;

  const calendarNightsRange = getRangeNightsString({
    startDateCell,
    endDateCell,
  });

  const nightsInterval = nights || calendarNightsRange;
  const nightsString = nightsInterval && convertNightsIntervalToString(nightsInterval);
  const nightsStringWords = nightsString?.split(' ');

  const isEmptyDatePicker = !nightsString && !startDate && !endDate;
  const isStartDateOnly = !nights && startDate && !endDate;

  return (
    <NightsBlock $isMobile={isMobile} $isShort={!!nightsStringWords}>
      {(nightsStringWords && (
        <>
          <span>
            {nightsStringWords[0]}
            <MoonIcon />
          </span>
          <span>{nightsStringWords[1]}</span>
        </>
      )) ||
        (isVacationOptionsAvailable &&
          ((isEmptyDatePicker && <span>Выберите даты начала путешествия</span>) ||
            (isStartDateOnly && (
              <>
                <Part>Выберите даты возвращения</Part>
                <Part>
                  или
                  <StyledButton type="button" variant="functional" onClick={selectPresetTab}>
                    <BlueMoonIcon />
                    <Part>количество ночей</Part>
                  </StyledButton>
                </Part>
              </>
            ))))}
    </NightsBlock>
  );
};

const NightsBlock = styled.div<{ $isMobile?: boolean; $isShort: boolean }>`
  display: flex;

  font-size: 14px;
  line-height: 16px;
  color: #ffffff;

  ${({ $isMobile, $isShort }) =>
    $isMobile &&
    !$isShort &&
    `
      flex-direction: column;
      align-items: center;
    `};
`;

const MoonIcon = styled(Moon)`
  width: 12px;
  transform: translate(0px, 1px);

  margin-right: 4px;

  path {
    fill: #ffffff;
  }
`;

const BlueMoonIcon = styled(MoonIcon as any)`
  margin-right: 4px;

  path {
    fill: #007aff;
  }
`;

const StyledButton = styled(ButtonTs)`
  cursor: pointer;
  margin-left: 4px;
  color: #007aff;
`;

const Part = styled.span`
  margin-right: 4px;
`;
